import React from 'react';
import i18n from '../../../i18n/i18n';
import axios from '../../../utils/AxiosWrapper';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Card, Link, Typography } from '@material-ui/core';
import DatePickerMeteo from '../../../utils/DatePickerMeteo';
import { formatData, formatForecast, formatDisease } from './../DataFormatters';
import { withStyles } from '@material-ui/core/styles';
import NavigationIcon from '@material-ui/icons/Navigation';
import { MoonLoader } from 'react-spinners';
import MeteoTable from '../MeteoTable';
import MeteoInfoButton from '../MeteoInfoButton';
import InfoWind from '../Info/Data/InfoWind';

const styles = {};

export class DataWind extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            station_id: this.props.row.uid,
            startDate: moment().subtract(7, 'days'),
            endDate: moment(),
            data: {},
            load: true
        };
    }

    setDates = (start, end) => { this.setState({ startDate: start, endDate: end }, () => { this.getPessl(); }); }

    getData = (path) => {
        axios.post('/api/testMeteo/meteo', path)
            .then(res => { let obj = formatData(res); this.setState({ data: obj, load: false }); })
            .catch(err => console.log('Error: ', err))
    }

    getPessl = () => {
        if (this.state.startDate !== null && this.state.endDate !== null) {
            let start_date = moment(this.state.startDate).unix();
            let end_date = moment(this.state.endDate).unix();
            let station_id = this.state.station_id;

            // URL-ovi za podatke sa meteo stanica
            let disease_path = '/data/' + station_id + '/hourly/from/' + start_date + '/to/' + end_date;
            let forecast_path = '/forecast/' + station_id + '/basic-1h';
            let data_path = '/data/' + station_id + '/hourly/from/' + start_date + '/to/' + end_date;

            // Disease mora POST method, za Data i Forecast mora GET method
            this.getData({ path: data_path, method: "GET" });
        };
    }
    getUser() {
            let user = localStorage.getItem('user');
            let userObject = JSON.parse(user);
            !user && window.location.replace(window.location.origin);
            return userObject;
        }
    render() {
        let user = this.getUser();
        const { classes } = this.props;

        // console.log('disease1: ', this.state.disease1);
        // console.log('disease2: ', this.state.disease2);
        // console.log('data meteo: ', this.state.data);

        let wind_dir = [];
        if (this.state.data.wind_dir !== undefined) wind_dir = distributedCopy(this.state.data.wind_dir, 12);

        let dates_dir = [];
        if (this.state.data.dates !== undefined) dates_dir = distributedCopy(this.state.data.dates, 12);

        let graph1 = {};

        if (
            this.state.data.dates &&
            this.state.data
        ) {
            graph1 = {
                labels: this.state.data.dates,
                datasets: [
                    {
                        data: this.state.data.wind_speed,
                        label: i18n.t('Wind speed [m/s]'),
                        backgroundColor: 'transparent',
                        borderColor: 'rgb(82, 162, 209)',
                        type: 'line',
                        borderWidth: 2,
                        pointBackgroundColor: 'rgb(82, 162, 209)', 
                        pointBorderColor: 'rgb(82, 162, 209)',
                        pointRadius: this.state.data.dates.length > 504 ? 0 : 2,
                    },
                    {
                        data: this.state.data.wind_gust,
                        label: i18n.t('Wind gust [m/s]'),
                        backgroundColor: 'transparent',
                        borderColor: 'rgb(11, 78, 117)',
                        type: 'line',
                        borderWidth: 2,
                        pointBackgroundColor: 'rgb(11, 78, 117)', 
                        pointBorderColor: 'rgb(11, 78, 117)',
                        pointRadius: this.state.data.dates.length > 504 ? 0 : 2,
                    },
                ],
            };

        };

        const options = {
            scales: {
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        // id: 'y-axis-1',
                        gridLines: {
                            drawOnChartArea: false,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '[m/s]'
                        },
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            // max: 100,
                        }
                    },
                ],
            },
        }

        return (
            <div style={{ paddingLeft: '35px' }}>
                 <div style= {{display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'center'}}>
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                        <p style={{fontSize: 20, marginRight: 4}}>{i18n.t('Wind speed and direction')}</p>
                        </div>
                        <div style={{marginLeft: 20}}>
                        <MeteoInfoButton
                            title={i18n.t('Wind speed and direction')}
                            text={<InfoWind />}
                            height='400px'
                            width='sm'
                            />
                        </div>
                </div>
                <DatePickerMeteo startDate={this.state.startDate} endDate={this.state.endDate} setDates={this.setDates} getPessl={this.getPessl} />
                {this.state.load === true && <div style={{ marginLeft: '39%', marginTop: '14%' }}> <MoonLoader loading={this.state.load} size={100} /></div>}
                {this.state.load === false &&
                    <div>
                        <div style={{ width: '95%', marginTop: '10px' }}>
                            <Bar data={graph1} height={300} width={600} options={options} />
                        </div>

                        <Typography style={{ textAlign: 'center', fontSize: '18px', margin: '10px', marginTop: '3%', marginBottom: '10px' }}>{i18n.t('Wind direction')}:</Typography>
                        {user.id_klijent !== 32743 && 
                        <table style={{ marginBottom: '58px' }}>
                            <tr>
                                {wind_dir !== [] && this.state.data.wind_dir !== undefined && wind_dir.map((item, i) => {
                                    return <td style={{ width: '75px', height: '50px', textAlign: 'center' }}>
                                        <NavigationIcon style={{ transform: `rotate(${item + 180}deg)`, height: '40px', width: '40px', color: 'rgb(82, 162, 209)' }} />
                                    </td>
                                })}
                            </tr>
                            <tr>
                                {wind_dir !== [] && this.state.data.wind_dir !== undefined && wind_dir.map((item, i) => {
                                    let string_degrees = degress(item);
                                    return <td style={{ width: '75px', height: '30px', textAlign: 'center' }}>
                                        <Typography>{string_degrees}</Typography>
                                    </td>
                                })}
                            </tr>
                            <tr>
                                {dates_dir !== [] && this.state.data.dates !== undefined && dates_dir.map((item, i) => {
                                    return <td style={{ width: '75px', height: '40px', textAlign: 'center' }}>
                                        <Typography>{item.substring(0, 5)}</Typography>
                                        <Typography>{item.substring(7, 12)}</Typography>
                                    </td>
                                })}
                            </tr>
                        </table>}

                        <div>
                            <MeteoTable data={{
                                headers: [i18n.t('Date and time'), i18n.t('Wind speed [m/s]'), i18n.t('Wind gust [m/s]'),],
                                dates: this.state.data.dates,
                                wind_speed: this.state.data.wind_speed,
                                wind_gust: this.state.data.wind_gust,
                            }} />
                        </div>
                        <div style={{ marginTop: '20px' }}></div>
                    </div>
                }
            </div>
        );
    }
}


export default withStyles(styles)(DataWind);

function distributedCopy(items, n) {
    var elements = [items[0]];
    var totalItems = items.length - 2;
    var interval = Math.floor(totalItems / (n - 2));
    for (var i = 1; i < n - 1; i++) {
        elements.push(items[i * interval]);
    }
    elements.push(items[items.length - 1]);
    return elements;
}

function degress(deg) {
    let string = '';
    if (deg > 348.75 || deg < 11.25) string = i18n.t('N');
    else if (deg > 11.25 && deg < 33.75) string = i18n.t('NNE');
    else if (deg > 33.75 && deg < 56.25) string = i18n.t('NE');
    else if (deg > 56.25 && deg < 78.75) string = i18n.t('ENE');
    else if (deg > 78.75 && deg < 101.25) string = i18n.t('E');
    else if (deg > 101.25 && deg < 123.75) string = i18n.t('ESE');
    else if (deg > 123.75 && deg < 146.25) string = i18n.t('SE');
    else if (deg > 146.25 && deg < 168.75) string = i18n.t('SSE');
    else if (deg > 168.75 && deg < 191.25) string = i18n.t('S');
    else if (deg > 191.25 && deg < 213.75) string = i18n.t('SSW');
    else if (deg > 213.75 && deg < 236.25) string = i18n.t('SW');
    else if (deg > 236.25 && deg < 258.75) string = i18n.t('WSW');
    else if (deg > 258.75 && deg < 281.25) string = i18n.t('W');
    else if (deg > 281.25 && deg < 303.75) string = i18n.t('WNW');
    else if (deg > 303.75 && deg < 326.75) string = i18n.t('NW');
    else if (deg > 326.75 && deg < 348.75) string = i18n.t('NNW');
    return string;
}